'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';
import { Icon } from '../icon/icon.component.js';

function _object_without_properties(e, t) {
    if (null == e) return {};
    var s, r, o = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)s = n[r], !(t.indexOf(s) >= 0) && Object.prototype.propertyIsEnumerable.call(e, s) && (o[s] = e[s]);
    }
    return o;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var s, r, o = {}, n = Object.keys(e);
    for(r = 0; r < n.length; r++)s = n[r], t.indexOf(s) >= 0 || (o[s] = e[s]);
    return o;
}
let i = {
    info: 'info',
    success: 'success',
    warning: 'warning',
    error: 'error',
    help: 'helpQuery'
};
const StatusMessage = renderWithRef('StatusMessage', null, (r, c)=>{
    useComponentStylesLoaded('StatusMessage', SWAN_STYLE_KEY_MAP.statusMessage);
    let { children: p, skin: u = 'info', size: l = 'standard', accessibleTextForIcon: m } = r, f = _object_without_properties(r, [
        "children",
        "skin",
        "size",
        "accessibleTextForIcon"
    ]);
    return jsxs(RenderComp, {
        classNames: new Set([
            'swan-status-message',
            `swan-status-message-skin-${u}`,
            `swan-status-message-size-${l}`
        ]),
        root: "div",
        forwardedRef: c,
        props: f,
        children: [
            jsx(Icon, {
                skin: u,
                iconType: i[u],
                size: l,
                alt: m || ''
            }),
            p
        ]
    });
});

export { StatusMessage };
